module.exports = __webpack_public_path__ + "img/text.cf045945.png";